// MySQL VARCHAR(191) limit for utf8mb4 encoding with InnoDB index constraints
// This is the maximum length for indexed string columns in Prisma with MySQL
export const PRISMA_MAX_STRING_LENGTH = 191;
